import {
  DerivativeQuestionFeedback,
  DerivativeQuestionReviewType,
  ReferenceQuestionFeedback,
  ReferenceQuestionReviewType,
  REVIEW_ACTION_TYPE_TO_DERIVATIVE_QUESTION_REVIEW_TYPE,
  REVIEW_ACTION_TYPE_TO_REFERENCE_QUESTION_REVIEW_TYPE,
} from '@examdojo/review';

interface FeedbackEvaluation {
  user_id: string | null;
  created_at: string;
}

export function shouldShowConsensusWarning<T extends FeedbackEvaluation, R>(
  evaluations: T[],
  userId: string,
  currentReviewType: R,
  getReviewTypeFromEvaluation: (evaluation: T) => R | undefined,
): boolean {
  evaluations = evaluations.toSorted((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());

  const lastUserEvaluationIndex = evaluations.findLastIndex(
    (e) => e.user_id === userId && getReviewTypeFromEvaluation(e) === currentReviewType,
  );

  if (lastUserEvaluationIndex === -1) {
    return false;
  }

  const evaluationsAfterUser = evaluations.slice(lastUserEvaluationIndex + 1);

  if (evaluationsAfterUser.length === 0) {
    return false;
  }

  return evaluationsAfterUser.every((e) => getReviewTypeFromEvaluation(e) === currentReviewType);
}

// Show consensus warning only if all reviews since user's last evaluation are consecutive in the same mode
export function shouldShowDerivativeQuestionConsensusWarning(
  evaluations: DerivativeQuestionFeedback[],
  userId: string,
  currentReviewType: DerivativeQuestionReviewType,
): boolean {
  return shouldShowConsensusWarning(
    evaluations,
    userId,
    currentReviewType,
    (e) => REVIEW_ACTION_TYPE_TO_DERIVATIVE_QUESTION_REVIEW_TYPE[e.action_type],
  );
}

export function shouldShowReferenceQuestionConsensusWarning(
  evaluations: ReferenceQuestionFeedback[],
  userId: string,
  currentReviewType: ReferenceQuestionReviewType,
): boolean {
  return shouldShowConsensusWarning(
    evaluations,
    userId,
    currentReviewType,
    (e) => REVIEW_ACTION_TYPE_TO_REFERENCE_QUESTION_REVIEW_TYPE[e.action_type],
  );
}
